import { ROLE_GROUPS } from '@moal/api'
import { useEffect, useState } from 'react'
import { getRoles, postRole } from '../../../utils/APIs/roles'

const InitializeRoles = () => {
  const [roles, setRoles] = useState()
  const [missing, setMissing] = useState(true)

  useEffect(() => {
    loadRoles()
  }, [])

  const loadRoles = async () => {
    const response = await getRoles()
    if (response && response.status === 200) {
      setRoles(response.data)
      setMissing(ROLE_GROUPS.ALL.length !== response.data?.length)
    }
  }

  const handleInitializeRoles = async () => {
    const existing = new Set(roles.map((r) => r.role))
    const missing = ROLE_GROUPS.ALL.filter((role) => !existing.has(role))
    await Promise.all(missing.map((role) => postRole(role.toLowerCase())))
  }

  return (
    <div className="flex flex-col gap-0.5">
      <p>Total Roles: {JSON.stringify(ROLE_GROUPS.ALL.length)}</p>
      <p>Existing Roles: {JSON.stringify(roles?.length)}</p>
      {!missing && <p>Roles are good to go!</p>}
      {missing && (
        <button
          onClick={() => handleInitializeRoles()}
          aria-label="Initialize Settings"
          className="button-fill w-fit"
          disabled={!missing}
        >
          Initialize Roles
        </button>
      )}
    </div>
  )
}

export default InitializeRoles
